import {
  INVOICE_TRANSACTION_DOC_NUMBER_FILTER,
  INVOICE_TRANSACTION_DOCUMENT_TYPE_FILTER
} from "constants/ActionTypes";

const initialState = {
  docNumberFilter: "",
  documentType: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case INVOICE_TRANSACTION_DOC_NUMBER_FILTER:
      return {
        ...state,
        docNumberFilter: action.payload,
      };
    case INVOICE_TRANSACTION_DOCUMENT_TYPE_FILTER:
      return {
        ...state,
        documentType: action.payload,
      };
    default:
      return state;
  }
};
